import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import AccountMenu from "./AccountMenu";
import LearningHistory from "./LearningHistory";

const Sidebar: React.FC = () => {
  const { user } = useAuth();
  const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
  const location = useLocation();
  const isHome =
    location.pathname === "/home" || location.pathname === "/home/";

  return (
    <div className="fixed h-full z-30 w-64 flex flex-col bg-slate-50 dark:bg-gray-950 border-r border-slate-200 dark:border-gray-900 transition-colors duration-200">
      {/* Brand */}
      <a
        href="/home"
        className="flex items-center gap-2.5 px-4 h-14 flex-shrink-0 hover:opacity-80 transition-opacity"
        onClick={(e) => {
          e.preventDefault();
          window.location.href = "/home";
        }}
      >
        <div className="w-7 h-7 rounded-lg overflow-hidden flex-shrink-0 shadow-sm">
          <img src="/a.png" alt="Einstein AI" className="w-full h-full object-cover" />
        </div>
        <span className="text-sm font-bold text-slate-800 dark:text-white tracking-tight">
          Einstein AI
        </span>
      </a>

      {/* New Learning */}
      <div className="px-3 mb-3">
        <Link
          to="/home"
          className={`flex items-center gap-2.5 w-full px-3 py-2.5 rounded-xl text-sm font-semibold transition-all duration-150
            ${isHome
              ? "bg-[#47b3fe] text-white shadow-sm"
              : "bg-white dark:bg-gray-900 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-gray-800 hover:border-slate-300 dark:hover:border-gray-700 hover:bg-slate-50 dark:hover:bg-gray-800"
            }`}
        >
          <div className={`w-5 h-5 rounded-md flex items-center justify-center flex-shrink-0 ${isHome ? "bg-white/20" : "bg-slate-100 dark:bg-gray-800"}`}>
            <i className={`fas fa-plus text-[10px] ${isHome ? "text-white" : "text-slate-500 dark:text-slate-400"}`}></i>
          </div>
          New Learning
        </Link>
      </div>

      {/* Divider */}
      <div className="mx-3 mb-3 border-t border-slate-200 dark:border-gray-800"></div>

      {/* History */}
      <nav className="flex-1 overflow-hidden flex flex-col px-3 pb-3">
        <LearningHistory />
      </nav>

      {/* User profile */}
      <div className="flex-shrink-0 border-t border-slate-200 dark:border-gray-900 p-3">
        <button
          onClick={() => setIsAccountMenuOpen(true)}
          className="flex items-center gap-3 w-full px-3 py-2.5 rounded-xl hover:bg-white dark:hover:bg-gray-900 border border-transparent hover:border-slate-200 dark:hover:border-gray-800 transition-all duration-150 group text-left"
        >
          {/* Avatar */}
          <div className="relative flex-shrink-0">
            <div className="w-8 h-8 rounded-full overflow-hidden ring-2 ring-white dark:ring-gray-950">
              {user?.photoURL ? (
                <img
                  src={user.photoURL}
                  alt={user.displayName || "User"}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-[#47b3fe]">
                  <span className="text-white text-xs font-bold">
                    {user?.displayName?.[0] ?? "U"}
                  </span>
                </div>
              )}
            </div>
            <div className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 bg-green-400 rounded-full border-2 border-slate-50 dark:border-gray-950"></div>
          </div>

          {/* Name + email */}
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-slate-800 dark:text-slate-100 truncate leading-tight">
              {user?.displayName || "User"}
            </p>
            <p className="text-xs text-slate-400 dark:text-slate-600 truncate mt-0.5">
              {user?.email || ""}
            </p>
          </div>

          {/* Settings icon */}
          <i className="fas fa-ellipsis text-slate-300 dark:text-gray-700 group-hover:text-slate-500 dark:group-hover:text-gray-400 transition-colors text-xs flex-shrink-0"></i>
        </button>
      </div>

      <AccountMenu
        isOpen={isAccountMenuOpen}
        onClose={() => setIsAccountMenuOpen(false)}
      />
    </div>
  );
};

export default Sidebar;
